import { reservationsRecommendationsSelector } from "./reservationsRecommendationsSelector";
import { RootState } from "../../../../store";
import { getCurrentReservationPotentialSavingsLoadingSelector } from "@/store/commitments/selectors/recommendations/data/getCurrentReservationPotentialSavingsLoadingSelector";

export const reservationsRecommendationsLoadingSelector = (
  state: RootState,
) => {
  const response = reservationsRecommendationsSelector(state);
  const loading = getCurrentReservationPotentialSavingsLoadingSelector(state);
  return response?.isLoading ?? loading;
};
